import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'Guía Principal: El Protocolo Vientre Plano 40+',
    desc: 'con el paso a paso científico.'
  }, {
    title: 'El Plan de Reseteo de 7 Días:',
    desc: 'Menú diario detallado para desinflamar el intestino.'
  }, {
    title: 'Lista de Compras "Zero-Inflamación":',
    desc: 'Para que sepas exactamente qué comprar sin perder tiempo.'
  }, {
    title: 'Técnica del "Sorbio Anti-Cortisol":',
    desc: 'El truco matutino para estabilizar tu energía.'
  }, {
    title: 'Guía de Micro-Hábitos:',
    desc: 'Cómo caminar y dormir para mantener el vientre plano a largo plazo.'
  }];
  return <SectionWrapper className="bg-white" id="que-recibes" data-id="element-185">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-charcoal" data-id="element-186">
        Esto es lo que recibes hoy
      </h2>

      <div className="flex flex-col md:flex-row gap-10 items-center" data-id="element-187">
        <div className="flex-1 space-y-6" data-id="element-188">
          {items.map((item, index) => <div key={index} className="flex items-start space-x-4" data-id="element-189">
              <div className="flex-shrink-0 bg-sage-light p-1.5 rounded-full mt-1" data-id="element-190">
                <CheckIcon className="w-5 h-5 text-sage" data-id="element-191" />
              </div>
              <p className="text-lg text-gray-700" data-id="element-192">
                <strong className="text-charcoal block md:inline" data-id="element-193">
                  {item.title}
                </strong>{' '}
                <span className="text-gray-600" data-id="element-194">{item.desc}</span>
              </p>
            </div>)}
        </div>

        <div className="flex-1 w-full max-w-sm mx-auto" data-id="element-195">
          <img src="https://cdn.magicpatterns.com/uploads/g9G8Hf4zV8CMRpUSrDsS1T/Vientre_Plano_402B.png" alt="Materiales del Protocolo" className="w-full h-auto rounded-xl shadow-lg" data-id="element-196" />
        </div>
      </div>
    </SectionWrapper>;
}